import ProfileSetting from "components/Profiles/ProfileSetting";
import NotFooterLayout from "layouts/NotFooterLayout";


function ProfileSettingPage() {

  return (
    <>
    <NotFooterLayout namePage="ตั้งค่าบัญชีผู้ใช้"  >
      <div className="layout-content">
       <ProfileSetting />
      </div>
      </NotFooterLayout>
    </>
  );
}

export default ProfileSettingPage;